import { Switch } from "@mui/material";
import { useState } from "react";
import classes from "../CustomInputs.module.css";

const SwitchInput = (props) => {
  // when leftChecked passed on props as true - shows the left option as the default selection
  const [leftChecked, setLeftChecked] = useState(props.leftChecked ? props.leftChecked : false);

  const handleSwitcher = (event) => {
    const { name } = event.target;
    const value = event.target.checked;
    props.onChange({ [name]: value });

    if (props.leftChecked) {
      setLeftChecked(!leftChecked);
    }

    if (props.resetDefault && !props.isPhoneVerified) {
      props.resetDefault();
    }
  };

  return (
    <div className={classes.appInput}>
      {props.icon && <img src={props.icon} />}
      <span className={`${classes.appText} ${leftChecked && !props.disabled ? classes.utronText : ''}`}>{props.leftText}</span>
      <Switch
        classes={{
          checked: classes.switchChecked,
          track: classes.switchTrack,
          switchBase: leftChecked && !props.disabled ? classes.switchChecked : ''
        }}
        className={classes.switch}
        name={props.id}
        checked={props.checked}
        disabled={props.disabled}
        onChange={handleSwitcher}
      />
      <span className={`${classes.appText} ${props.checked ? classes.utronText : ''}`}>{props.rightText}</span>
    </div>
  );
};

export default SwitchInput;
